import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-employeewise-closed-tickets',
  templateUrl: './employeewise-closed-tickets.component.html',
  styleUrls: ['./employeewise-closed-tickets.component.css']
})
export class EmployeewiseClosedTicketsComponent implements OnInit {
  e:any={};
  UsersList: any=[];

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.GetAllInternalUsers();
  }

  EmployeewiseClosedTicketsReport = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.employeewiseClosedTicketsReport(this.e.FromDate,this.e.ToDate,this.e.IS_To_UserId)
    .subscribe((data:any)=>{
      this.TicketsList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}


GetAllInternalUsers() {
  document.getElementById('loader-spinner').style.display = "block";
  this.userService.getInternalUsersForDropdown()
    .subscribe(
      (data: any) => {
        this.UsersList = data;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
}



Print = function () {
  window.print()
}

}



// WEBPACK FOOTER //
// ./src/app/reports/employeewise-closed-tickets/employeewise-closed-tickets.component.ts